<form
  *ngIf="formInitialized"
  [formGroup]="form"
  (ngSubmit)="onSubmit()"
  class="p-fluid">
  <app-form-field-wrapper
    label="Bezeichnung"
    name="title"
    [formField]="form.get('title')">
    <input pInputText id="title" type="text" formControlName="title" />
  </app-form-field-wrapper>

  <app-form-field-wrapper
    label="Quelle"
    name="source"
    [formField]="form.get('source')">
    <input pInputText id="source" type="text" formControlName="source" />
  </app-form-field-wrapper>

  <div class="flex gap-5 align-items-start p-2 pt-6">
    <p-fileUpload
      mode="basic"
      chooseLabel="auswählen & hochladen"
      chooseIcon="pi pi-upload"
      name="imagePool"
      [url]="uploadUrl"
      [auto]="true"
      accept="image/*"
      maxFileSize="5000000"
      invalidFileSizeMessageSummary="Upload fehlgeschlagen!"
      invalidFileSizeMessageDetail="Laden Sie bitte maximal 5MB hoch."
      invalidFileTypeMessageSummary="Upload fehlgeschlagen!"
      invalidFileTypeMessageDetail="Nur Bild-Uploads sind erlaubt."
      (onUpload)="onUpload($event)" />

    @if (this.form.value.src) {
      <div class="p-card p-0 overflow-hidden">
        <div class="h-6rem w-8rem">
          <img
            [ngSrc]="imagePath"
            [alt]="this.form.value.src"
            fill
            priority
            style="
              position: static;
              object-fit: contain;
              object-position: 50% 50%;
            " />
        </div>
      </div>
    }

    <app-alert severity="info" [canToggle]="false" styleClass="m-0 p-3">
      <strong class="flex gap-2 align-items-center mb-2"
        ><i class="fas fa-info-circle"></i> Upload-Richtlinien</strong
      >
      <p>
        Max. 250 KB • 1920×1080 px • 72 dpi<br />
        Formate: JPEG (Fotos), SVG (Logos), WebP (Transparenz)
      </p>
      <div class="text-sm">
        <i
          >Hinweis: je geringer die Dateigröße, desto schneller die Ladezeit
          Ihrer Ansicht.</i
        >
      </div>
    </app-alert>
  </div>

  <p-divider></p-divider>

  <app-form-footer
    [cancelLevel]="1"
    [showRemoveButton]="!!itemToEdit"
    [isEditMode]="!!itemToEdit"
    (cancel)="onCancel()"
    (removeClick)="
      itemToEdit ? confirm(undefined, itemToEdit, itemToEdit.title) : undefined
    "></app-form-footer>
</form>
